import { modalCampusCreate, modalCampusUpdate } from './modalCampus';
import { modalCommentatorCreate } from './modalCommentator';
import { modalSlide } from './modalSlide';
import { modalImgCreate } from './modalImgOnly';
import { modalClub, modalClubUpdate } from './modalClub';

export function modalConfig() {
  if (document.querySelector('.js-modalEle')) {
    const modalEle = document.querySelector('.js-modalEle');
    const modalContEle = document.querySelector('.js-modalContEle');
    const modalClose = document.querySelector('.js-modalClose');
    const modalOverlay = document.querySelector('.js-modalOverlay');
    const modalTrigger = document.querySelectorAll('.js-modalTrigger');
    const modalPrev = document.querySelector('.js-modalPrev');
    const modalNext = document.querySelector('.js-modalNext');
    const IS_ACTIVE = 'is-active';
    const IS_VIEW = 'is-view';

    modalTrigger.forEach((target) => {
      target.addEventListener('click', () => {
        if (target.classList.contains('js-modalCommentator')) {
          // ここにcommentator用の関数をimport
          const createData = modalCommentatorCreate(target);
          modalContEle.appendChild(createData);

          modalEle.classList.add(IS_VIEW);
        }

        // キャンパスページ用のモーダル
        if (target.classList.contains('js-modalCampus')) {
          // ここにcommentator用の関数をimport
          const createData = modalCampusCreate(target);
          modalContEle.appendChild(createData);
          modalSlide(target);

          // flag用のclassを付与
          for (let i = 0; i < modalTrigger.length; i++) {
            modalTrigger[i].classList.remove(IS_ACTIVE);
          }
          target.classList.add(IS_ACTIVE);

          modalEle.classList.add(IS_VIEW);
        }

        // 画像のみ表示させる用のモーダル
        if (document.querySelector('.js-modalImgOnly')) {
          // ここにcommentator用の関数をimport
          const createData = modalImgCreate(target);
          modalContEle.appendChild(createData);

          modalEle.classList.add(IS_VIEW);
        }

        //クラブ・サークル紹介
        if (target.classList.contains('js-modalClub')) {
          const modalId = target.dataset.modal;
          const createData = modalClub(modalId);
          modalContEle.appendChild(createData);
          modalEle.classList.add(IS_VIEW);
        }
      });
    });

    // 生成した要素を閉じるボタンで削除
    modalClose.addEventListener('click', () => {
      const modalCreateBox = document.querySelector('.c-modal_box');
      modalContEle.removeChild(modalCreateBox);

      modalEle.classList.remove(IS_VIEW);
    });

    // 生成した要素を背景オーバーレイで削除
    modalOverlay.addEventListener('click', () => {
      const modalCreateBox = document.querySelector('.c-modal_box');
      modalContEle.removeChild(modalCreateBox);

      modalEle.classList.remove(IS_VIEW);
    });

    /** モーダル矢印操作 */
    if (document.querySelector('.js-modalCampus')) {
      // 前に戻る
      modalPrev.addEventListener('click', () => {
        const thisActiveEle = document.querySelector('.js-modalTrigger.is-active');
        thisActiveEle.classList.remove(IS_ACTIVE);

        if (thisActiveEle.previousElementSibling) {
          // 前の要素が存在している時
          const prevEle = thisActiveEle.previousElementSibling;

          prevEle.classList.add(IS_ACTIVE);

          // 削除して再生成だと画面がちらつくので
          // 削除せず更新用の関数を実行する
          modalCampusUpdate(prevEle);
        } else {
          // 前の要素が存在しない時、最後の要素を取得
          const thisAll = thisActiveEle.closest('ul').querySelectorAll('.js-modalTrigger');
          const lastEle = thisAll[thisAll.length - 1];
          lastEle.classList.add(IS_ACTIVE);

          // 削除して再生成だと画面がちらつくので
          // 削除せず更新用の関数を実行する
          modalCampusUpdate(lastEle);
        }
      });

      // 次に進む
      modalNext.addEventListener('click', () => {
        const thisActiveEle = document.querySelector('.js-modalTrigger.is-active');
        thisActiveEle.classList.remove(IS_ACTIVE);

        if (thisActiveEle.nextElementSibling) {
          // 次の要素が存在している時
          const nextEle = thisActiveEle.nextElementSibling;

          nextEle.classList.add(IS_ACTIVE);

          // 削除して再生成だと画面がちらつくので
          // 削除せず更新用の関数を実行する
          modalCampusUpdate(nextEle);
        } else {
          // 次の要素が存在しない時、最初の要素を取得
          const thisAll = thisActiveEle.closest('ul').querySelectorAll('.js-modalTrigger');
          const firstEle = thisAll[0];
          firstEle.classList.add(IS_ACTIVE);

          // 削除して再生成だと画面がちらつくので
          // 削除せず更新用の関数を実行する
          modalCampusUpdate(firstEle);
        }
      });
    }

    if (document.querySelector('.js-modalClub')) {
      modalPrev.addEventListener('click', () => {
        modalClubUpdate(document.querySelector('.c-modal_box'), 'prev');
      });

      modalNext.addEventListener('click', () => {
        modalClubUpdate(document.querySelector('.c-modal_box'), 'next');
      });
    }
  }
}
